export const isBackgroundEqualToBody = element => {
    const body = document.querySelector('body');
    const bodyBackground = getComputedStyle(body).backgroundColor;

    const elementBackground = getComputedStyle(element).backgroundColor;

    return bodyBackground === elementBackground;
};
